import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserService } from '../services/user-service';
import { Router } from '@angular/router';
import { AuthService } from '../auth';
import { RouterModule } from '@angular/router';
import { StorageService } from '../auth/storage.service';
import { AccountInfo } from '@azure/msal-browser';

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, MatIconModule, RouterModule],
  templateUrl: './nav-bar.html',
  styleUrl: './nav-bar.scss',
})
export class NavBar implements OnInit {
  storageService = inject(StorageService);
  authService = inject(AuthService);
  userService = inject(UserService);
  router = inject(Router);

  initials = '';
  name = '';

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe((result) => {
      if (result && result.account) {
        const currentAccount = result.account;
        if (currentAccount) {
          this.setDisplayName(currentAccount);
        }
      }
    });

    this.authService.getCurrentAccount().then((currentAccount) => {
      if (currentAccount) {
        this.setDisplayName(currentAccount);
      }
    });
  }

  setDisplayName(currentAccount: AccountInfo | null): void {
    if (!currentAccount) {
      this.storageService.clear();
      return;
    }

    this.name = currentAccount.name?.trim() ?? '';
    const parts = this.name.split(/\s+/).filter(Boolean).slice(0, 2);

    this.name = parts.reverse().join(' ');
    this.initials = parts.map((p) => p[0].toUpperCase()).join('');
  }

  handleLogout(): void {
    this.authService
      .logout()
      .then(() => {
        this.clearStorage();
      })
      .catch((error) => {
        console.error('Logout failed', error);
        this.clearStorage();
      });
  }

  clearStorage(): void {
    this.storageService.clear();
    this.storageService.set('permissionChecked', false);
    this.router.navigate(['/']);
  }
}
